module.exports = __webpack_public_path__ + "img/support.3cc6d0c4.png";